import styled, { css } from 'styled-components';

import Input from 'components/ui/Input';
import Select from 'components/ui/Select';
import { ModalBottomRow } from 'components/ui/Modal/Modal.styles';

import { colours } from 'themes/default';

export const IntroText = styled.p`
  margin: 0 0 16px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`;

export const FieldControl = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`;

export const FieldLabel = styled.label`
  font-weight: bold;
  margin-bottom: 8px;
`;

export const RequiredMark = styled.span`
  color: ${colours.Messaging.ErrorRed};
  margin-left: 4px;
`;

export const StyledInput = styled(Input)`
  box-sizing: border-box;
  min-height: 40px;

  ${({ validationState }) =>
    validationState === 'error' &&
    css`
      &:focus {
        box-shadow: none;
      }
    `}
`;

export const StyledSelect = styled(Select)`
  box-sizing: border-box;
  min-height: 40px;
`;

export const ErrorMessage = styled.div`
  color: ${colours.Messaging.ErrorRed};
  font-size: 11px;
  line-height: 14px;
  min-height: 14px;
  margin-top: 4px;
  max-width: 100%;
  overflow-wrap: anywhere;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;

export const ButtonRow = styled(ModalBottomRow)`
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
`;
